// Where the Coach dashboard's links go. A Coach reaches these at the top level; an Admin visiting
// a Coach reaches the same pages under /coach/:coachId/ (the top-level paths fall into the Admin
// catch-all). The ids come from the URL, so they are encoded.
export const coachRoutes = ({ coachId, isVisit }) => {
    const base = isVisit ? `/coach/${encodeURIComponent(coachId)}` : '';
    return { groups: `${base}/groups`, programs: `${base}/programs`, athletes: `${base}/athletes` };
};
